export const CLIENT_ID = "spa-operacional";
